import { useContext } from "react";
import { AppContext } from "../App";
import babyClothing from "../assets/baby_clothing.jpg";
import diapers from "../assets/diapers.jpg";
import uniforms from "../assets/uniform.jpg";
import appliances from "../assets/kitchen_appliances2.jpg";
import office from "../assets/computers.jpg";
import cleaning from "../assets/cleaning_living_rooms.jpg";
import headerBg from "../assets/cleaning.jpg";

export const services = [
  {
    slug: "children-and-family-products",
    title: "Children and family products",
    image: babyClothing,
    shortDescription:
      "Children products, wears, diapers, women pads, and essential family care stock.",
    description:
      "We import and supply practical family-care essentials with attention to quality, affordability, and consistent availability for wholesale and direct clients.",
    features: [
      "Children clothing and baby wear",
      "Diapers and hygiene essentials",
      "Women pads and personal care lines",
      "Affordable family-focused sourcing",
    ],
    highlight:
      "A dependable category for retailers, institutions, and buyers who need trusted family essentials.",
  },
  {
    slug: "uniforms-beddings-and-clothing",
    title: "Uniforms, beddings, and clothing",
    image: uniforms,
    shortDescription:
      "Uniform supply, clothing support, and bedding solutions for institutions and commercial clients.",
    description:
      "Our supply offering includes uniforms, garments, bedding items, and related textile solutions suitable for schools, hospitality, offices, and organized programs.",
    features: [
      "Uniform sourcing and supply",
      "Beddings and linen support",
      "General clothing categories",
      "Institution-ready supply options",
    ],
    highlight:
      "Designed for clients who need smart, coordinated, and functional textile supply.",
  },
  {
    slug: "appliances-and-home-essentials",
    title: "Appliances and home essentials",
    image: appliances,
    shortDescription:
      "Kitchen and home appliances backed by practical sourcing and quality-focused distribution.",
    description:
      "We supply kitchen and home appliances that support modern living, workplace convenience, and institutional operations with products selected for everyday use.",
    features: [
      "Kitchen appliances",
      "Home appliances",
      "Consumables and essentials",
      "Quality and affordability balance",
    ],
    highlight:
      "Useful, reliable appliance categories that fit both domestic and commercial environments.",
  },
  {
    slug: "office-electrical-and-furnishing-solutions",
    title: "Office, electrical, and furnishing solutions",
    image: office,
    shortDescription:
      "Office equipment, furniture, fittings, and electrical materials for productive spaces.",
    description:
      "We help businesses and institutions equip their spaces through supply of office equipment, furniture, fittings, and electrical materials that support efficient operations.",
    features: [
      "Office equipment",
      "Furniture and fittings",
      "Electrical materials",
      "Workspace-ready procurement support",
    ],
    highlight:
      "A strong category for professional spaces that need cohesive and dependable setup support.",
  },
  {
    slug: "cleaning-and-deep-care-services",
    title: "Cleaning and deep care services",
    image: cleaning,
    shortDescription:
      "Residential and deep cleaning services delivered with detail, care, and consistency.",
    description:
      "Our cleaning services cover living areas, kitchens, bathrooms, bedrooms, and deeper treatment for cabinets, upholstery, ovens, fan blades, walls, and more.",
    features: [
      "Mopping, vacuuming, dusting, and sweeping",
      "Kitchen, bathroom, bedroom, and living-room cleaning",
      "Cabinet, countertop, and appliance cleaning",
      "Deep-clean treatment for detailed surfaces and fixtures",
    ],
    highlight:
      "A polished service for clients who want cleaner, healthier, and more presentable spaces.",
  },
  {
    slug: "hygiene-and-consumable-supply",
    title: "Hygiene and consumable supply",
    image: diapers,
    shortDescription:
      "High-demand consumables and hygiene products sourced to support recurring customer needs.",
    description:
      "We provide recurring-use goods that help retailers, institutions, and businesses maintain stock continuity in fast-moving product lines with dependable sourcing and timely delivery.",
    features: [
      "Consumables for routine use",
      "Personal care and hygiene lines",
      "Flexible supply support",
      "Reliable replenishment planning",
    ],
    highlight:
      "A practical supply category built around repeat demand and dependable product flow.",
  },
];

const commitments = [
  "Affordable quality with a business-first mindset",
  "Timely deliveries and responsive customer support",
  "Service coverage for homes, institutions, offices, and retail operations",
];

export default function ServicesContent() {
  const appContext = useContext(AppContext);

  return (
    <>
      <section className="page-hero page-hero-services" style={{backgroundImage: `url(${headerBg})`, backgroundSize: 'cover', backgroundPosition: 'center', width: "100%", height: "100%", objectFit: "cover"}}>
        <div className="container">
          <div className="page-hero-content">
            <h1 data-aos="fade-right" data-aos-delay="100">Confidence in supply and Excellence in cleanliness</h1>
            <p data-aos="fade-up" data-aos-delay="200">
              We serve customers with an integrated mix of product importation,
              supplies, and cleaning services shaped for real operational needs.
            </p>
          </div>
        </div>
      </section>

      <section className="section-shell">
        <div className="container">
          <div className="section-heading-row">
            <div>
              <h2 data-aos="fade-right" data-aos-delay="100">Our service portfolio</h2>
              <p data-aos="fade-up" data-aos-delay="200">
                Explore the major categories through which MS Universal
                Distributors supports households, institutions, and commercial
                clients.
              </p>
            </div>
          </div>

          <div className="row g-4">
            {services.map((service) => (
              <div key={service.slug} className="col-md-6 col-xl-4" data-aos="fade-up" data-aos-delay="100">
                <button
                  className="service-card service-card-large text-start h-100 w-100 p-0"
                  onClick={() =>
                    appContext.navTo({ item: "services", subItem: service.slug })
                  }
                >
                  <img src={service.image} alt={service.title} className="service-card-image" />
                  <div className="service-card-body">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <span className="service-card-link">Open Details</span>
                  </div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-shell section-soft">
        <div className="container">
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7">
              <div className="editorial-panel h-100" data-aos="fade-up" data-aos-delay="100">
                <h2>Why clients choose MS Universal Distributors</h2>
                <p>
                  We do more than supply products. We help customers maintain
                  standards, improve efficiency, and work with a partner that
                  understands quality, affordability, and time-sensitive delivery.
                </p>
                <div className="bullet-grid">
                  {commitments.map((item) => (
                    <div key={item} className="bullet-grid-item">
                      <span />
                      <p>{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-lg-5" data-aos="fade-up" data-aos-delay="300">
              <div className="vision-panel h-100">
                <h3>Operational focus</h3>
                <p>
                  Our team is positioned to support procurement decisions,
                  repeated supply needs, and service delivery with professionalism
                  and clarity.
                </p>
                <p>
                  Whether the request involves household goods, institutional
                  supply, or detailed cleaning, we bring a responsive and
                  dependable approach.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
